import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { Text } from "@/components"
import { DealTrend } from "@/types"
import { Box } from "@chakra-ui/react"

interface Props {
  trendData: DealTrend[]
}

export const DealTrendsChart = ({ trendData }: Props) => {
  return (
    <Box w="100%" p={5} border="1px" borderColor="gray.200" borderRadius={10} boxShadow="sm" bg="white">
      <Text fontSize="xs" color="gray.500">Total Deals:</Text>
      <Text fontSize="3xl" color="black" fontWeight="bold" mb={5}>{trendData.reduce((sum, item) => sum + item.count, 0).toLocaleString()}</Text>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={trendData}>
          <XAxis dataKey="month" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Line type="natural" dataKey="count" />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  )
}